import React, { useState, useEffect } from "react";
import ApexCharts from "react-apexcharts";

import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  onSnapshot,
  doc,
  query,
  where,
  orderBy,
  getDoc,
} from "firebase/firestore";
import { db, storage, app } from "../firebase";
const Chart = () => {
  // Initialize Firestore

  // Get the current date and time
  var today = new Date();
  var yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  // Get the orders collection from Firestore

  // State to store the order details
  const [todayOrders, setTodayOrders] = useState([]);
  const [yesterdayOrders, setYesterdayOrders] = useState([]);

  useEffect(() => {
    // Get the orders placed today and yesterday
    onSnapshot(
      query(collection(db, "orders"), where("created_at", ">=", today)),
      (snapshot) => {
        setTodayOrders(snapshot.docs.map((doc) => doc.data()));
      }
    );

    onSnapshot(
      query(
        collection(db, "orders"),
        where("created_at", ">=", yesterday),
        where("created_at", "<", today)
      ),
      (snapshot) => {
        setYesterdayOrders(snapshot.docs.map((doc) => doc.data()));
      }
    );
  }, []);

  // Extract the hour from the created_at of each order
  var todayOrderHours = todayOrders.map(function (order) {
    return new Date(order.created_at.toDate()).getHours();
  });
  var yesterdayOrderHours = yesterdayOrders.map(function (order) {
    return new Date(order.created_at.toDate()).getHours();
  });

  // Count the number of orders placed on each hour
  var todayCounts = {};
  var yesterdayCounts = {};
  for (var i = 0; i < 24; i++) {
    todayCounts[i] = todayOrderHours.filter(function (hour) {
      return hour === i;
    }).length;
    yesterdayCounts[i] = yesterdayOrderHours.filter(function (hour) {
      return hour === i;
    }).length;
  }

  // Extract the labels (hours) and data (order counts) from the counts objects
  var labels = Object.keys(todayCounts);
  var todayData = labels.map(function (label) {
    return todayCounts[label];
  });
  var yesterdayData = labels.map(function (label) {
    return yesterdayCounts[label];
  });

  // Chart options
  const options = {
    chart: {
      type: "area",
    },
    xaxis: {
      categories: labels,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    series: [
      {
        name: "Today",
        data: todayData,
      },
      {
        name: "Yesterday",
        data: yesterdayData,
      },
    ],
  };
  return (
    <ApexCharts
      options={options}
      series={options.series}
      type="area"
      height={350}
    />
  );
};

export default Chart;
